import gql from 'graphql-tag';
import { editorBlockFragment } from '@/editor/api/graphql/editor-block.fragment';

export const removeDocumentPageMutation = gql`
  mutation RemoveDocumentPage($id: String!) {
    removeDocumentPage(id: $id)
  }
`;

export const getUploadFilesUrlsMutation = gql`
  mutation GetUploadFilesUrls($documentId: String!, $filenames: [String!]!) {
    getUploadFilesUrls(documentId: $documentId, filenames: $filenames) {
      uniqueFilename
      uploadUrl
    }
  }
`;

export const uploadFilesDoneMutation = gql`
  mutation UploadFilesDone($documentId: String!, $index: Int!, $uniqueFilenames: [String!]!) {
    uploadFilesDone(documentId: $documentId, index: $index, uniqueFilenames: $uniqueFilenames)
  }
`;

export const addDocumentPageMutation = gql`
  mutation AddDocumentPage(
    $documentId: String!
    $pageNum: Int!
    $videoId: String
    $blockId: String
    $pageType: DocumentPageType
  ) {
    addDocumentPage(
      documentPageInput: {
        documentId: $documentId
        pageNum: $pageNum
        videoId: $videoId
        blockId: $blockId
        pageType: $pageType
      }
    ) {
      id
      thumbUrl
      pageType
      pageNum
      video {
        id
        videoUrl
      }
      contentLinkBlock {
        buttonText
        description
        id
        thumbUrl
        thumbExtension
        title
        url
      }
      editorBlock {
        ...editorBlockFragment
      }
    }
  }
  ${editorBlockFragment}
`;

export const updateDocumentMutation = gql`
  mutation updateDocument(
    $documentId: String!
    $name: String
    $contractStartDate: String
    $contractEndDate: String
    $value: Int
    $expirationDate: String
    $isSigningInitials: Int
    $isSigningBiometric: Int
    $isSigningForward: Int
    $isPrivate: Int
    $isSigning: Int
    $isSelfsign: Int
    $isSigningOrder: Int
    $type: DocumentType
    $userId: String
  ) {
    updateDocument(
      documentId: $documentId
      name: $name
      contractStartDate: $contractStartDate
      contractEndDate: $contractEndDate
      value: $value
      expirationDate: $expirationDate
      isSigningInitials: $isSigningInitials
      isSigningBiometric: $isSigningBiometric
      isSigningForward: $isSigningForward
      isPrivate: $isPrivate
      isSigning: $isSigning
      isSelfsign: $isSelfsign
      isSigningOrder: $isSigningOrder
      type: $type
      userId: $userId
    ) {
      id
    }
  }
`;

export const createRecipientMutation = gql`
  mutation CreateRecipient($documentId: String!, $contactId: String!, $role: RoleType) {
    createRecipient(documentId: $documentId, contactId: $contactId, role: $role) {
      id
      firstName
      lastName
      fullName
      companyName
      companyNumber
      title
      mobile
      email
      thumbUrl
      gender
      role
      orderNum
      verifyEid
      verifyEidType
      verifyLinkedin
      verifyQna
      verifySms
    }
  }
`;

export const deleteRecipientMutation = gql`
  mutation DeleteRecipient($id: String!) {
    deleteRecipient(id: $id)
  }
`;

export const updateRecipientMutation = gql`
  mutation UpdateRecipient(
    $id: String!
    $contactId: String
    $role: String
    $roleName: String
    $status: String
    $orderNum: Int
    $firstName: String
    $lastName: String
    $companyId: String
    $companyName: String
    $companyNumber: String
    $title: String
    $phone: String
    $mobile: String
    $email: String
    $thumbUrl: String
    $note: String
    $gender: String
    $verifyQna: Boolean
    $verifyQnaOpen: Boolean
    $verifyQnaSign: Boolean
    $verifyQnaQuestion: String
    $verifyQnaAnswer: String
    $verifySms: Boolean
    $verifySmsOpen: Boolean
    $verifySmsSign: Boolean
    $verifySmsNumber: String
    $verifySmsCode: String
    $verifyLinkedin: Boolean
    $verifyEid: Boolean
    $verifyEidType: EIdSignType
    $verifyEidNumber: String
  ) {
    updateRecipient(
      id: $id
      contactId: $contactId
      role: $role
      roleName: $roleName
      status: $status
      orderNum: $orderNum
      firstName: $firstName
      lastName: $lastName
      companyId: $companyId
      companyName: $companyName
      companyNumber: $companyNumber
      title: $title
      phone: $phone
      mobile: $mobile
      email: $email
      thumbUrl: $thumbUrl
      note: $note
      gender: $gender
      verifyQna: $verifyQna
      verifyQnaOpen: $verifyQnaOpen
      verifyQnaSign: $verifyQnaSign
      verifyQnaQuestion: $verifyQnaQuestion
      verifyQnaAnswer: $verifyQnaAnswer
      verifySms: $verifySms
      verifySmsOpen: $verifySmsOpen
      verifySmsSign: $verifySmsSign
      verifySmsNumber: $verifySmsNumber
      verifySmsCode: $verifySmsCode
      verifyLinkedin: $verifyLinkedin
      verifyEid: $verifyEid
      verifyEidType: $verifyEidType
      verifyEidNumber: $verifyEidNumber
    ) {
      id
    }
  }
`;

export const updateDocumentAttachmentMutation = gql`
  mutation UpdateDocumentAttachment(
    $id: String!
    $requireView: Boolean
    $accessRecipientList: [String!]
  ) {
    updateDocumentAttachment(
      id: $id
      requireView: $requireView
      accessRecipientList: $accessRecipientList
    ) {
      id
    }
  }
`;

export const removeDocumentAttachmentMutation = gql`
  mutation RemoveDocumentAttachment($id: String!) {
    removeDocumentAttachment(id: $id)
  }
`;

export const updateDocumentFromTemplateMutation = gql`
  mutation UpdateDocumentFromTemplate(
    $documentId: String!
    $templateId: String!
    $pageOffset: Int!
  ) {
    updateDocumentFromTemplate(
      documentId: $documentId
      templateId: $templateId
      pageOffset: $pageOffset
    ) {
      id
      name
      isSigning
      isSigningOrder
      isSelfsign
      type
      tags {
        title
        status
        id
      }
      value
      contractStartDate
      contractEndDate
      expirationDate
      isSigningBiometric
      isSigningInitials
      isSigningForward
      isPrivate
      previewUrl
      externalEditorId
      externalEditorType
      user {
        email
        firstName
        lastName
        fullName
        id
        thumbUrl
      }
      recipients {
        firstName
        lastName
        fullName
        companyName
        companyNumber
        title
        mobile
        email
        thumbUrl
        gender
        role
        roleName
        id
        orderNum
        verifyEid
        verifyLinkedin
        verifyQna
        verifySms
      }
      pages {
        id
        thumbUrl
        pageType
        pageNum
        pageHeight
        pageWidth
        cropBoxH
        cropBoxW
        video {
          id
          thumbUrl
          videoUrl
        }
        contentLinkBlock {
          buttonText
          description
          id
          thumbUrl
          thumbExtension
          title
          url
        }
        editorBlock {
          ...editorBlockFragment
        }
      }
      video {
        video {
          id
          thumbUrl
          videoUrl
          videoType
        }
      }
      documentAttachments {
        id
        restrictAccess
        requireView
        createdAt
        previewUrl
        attachment {
          attachmentType
          attachmentTitle
          attachmentDescription
          attachmentUrl
          attachmentFilename
          attachmentSize
          attachmentSha
          thumbUrl
          published
          library
          hashId
        }
        accessRecipientList {
          id
          firstName
          lastName
          fullName
          roleName
        }
      }
    }
  }
  ${editorBlockFragment}
`;

export const deleteDocumentsMutation = gql`
  mutation DeleteDocuments($ids: [String!]!) {
    deleteDocuments(ids: $ids) {
      id
    }
  }
`;

export const sortDocumentPagesMutation = gql`
  mutation SortDocumentPages(
    $documentId: String!
    $documentPageIds: [String!]!
    $pageNums: [Int!]!
  ) {
    sortDocumentPages(
      payload: { documentId: $documentId, documentPageIds: $documentPageIds, pageNums: $pageNums }
    ) {
      id
      thumbUrl
      pageType
      pageNum
      pageHeight
      pageWidth
      cropBoxH
      cropBoxW
      video {
        id
        thumbUrl
        videoUrl
      }
      contentLinkBlock {
        buttonText
        description
        id
        thumbUrl
        thumbExtension
        title
        url
      }
    }
  }
`;

export const updateRecipientOrderMutation = gql`
  mutation UpdateRecipientOrder($documentId: String!, $recipientOrder: [RecipientOrderInput!]!) {
    updateRecipientOrder(documentId: $documentId, recipientOrder: $recipientOrder) {
      id
    }
  }
`;

export const updateDocumentPageMutation = gql`
  mutation UpdateDocumentPage(
    $id: String!
    $pageType: DocumentPageType
    $videoId: String
    $blockId: String
  ) {
    updateDocumentPage(
      documentPage: { id: $id, videoId: $videoId, blockId: $blockId, pageType: $pageType }
    ) {
      id
      thumbUrl
      pageType
      pageNum
      pageHeight
      pageWidth
      cropBoxH
      cropBoxW
      video {
        id
        thumbUrl
        videoUrl
        videoTitle
      }
      contentLinkBlock {
        buttonText
        description
        id
        thumbUrl
        thumbExtension
        title
        url
      }
      editorBlock {
        ...editorBlockFragment
      }
    }
  }
  ${editorBlockFragment}
`;

export const sealDocumentMutation = gql`
  mutation SealDocument($documentId: String!, $sendDocument: Boolean!) {
    sealDocument(documentId: $documentId, sendDocument: $sendDocument)
  }
`;

export const updateSignatureMutation = gql`
  mutation UpdateSignature($signature: String!) {
    updateSignature(signature: $signature)
  }
`;
